import { render } from "./ShoppingProcess.vue?vue&type=template&id=5173c8c8&scoped=true"
const script = {}

import "./ShoppingProcess.vue?vue&type=style&index=0&id=5173c8c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5173c8c8"

export default script